/*
 * @Description:工业管理
 * @Date: 2022-03-10 10:43:02
 */
import Home from '../views/home.vue';

export const route = [
  {
    path: '/main/home/index',
    component: Home,
    meta: {
      title: '首页'
    }
  }
];
